export enum ECategoryType {
  CATEGORY = 'category',
  SUB_CATEGORY = 'subCategory'
}

export interface ISelectedCategory {
  id: string
  type: ECategoryType
}

export interface IGoodsListSellerOption {
  label: string
  value: string
  key: string
}
